import { combineReducers } from 'redux';

import booking from './booking';
import type { BookingState } from './booking';
import business from './business';
import type { BusinessState } from './business';
import cart from './cart';
import type { CartState } from './cart';
import config from './config';
import type { ConfigState } from './config';
import estimate from './estimate';
import type { EstimateState } from './estimate';
import information from './information';
import type { InformationState } from './information';
import services from './services';
import type { ServicesState } from './services';
import sites from './sites';
import type { SitesState } from './sites';
import trip from './trip';
import type { TripState } from './trip';

export interface State {
  booking: BookingState;
  sites: SitesState;
  estimate: EstimateState;
  services: ServicesState;
  cart: CartState;
  business: BusinessState;
  config: ConfigState;
  information: InformationState;
  trip: TripState;
}

export default combineReducers({
  booking,
  sites,
  estimate,
  services,
  cart,
  business,
  config,
  trip,
  information,
});
